import { formatDistanceToNowStrict } from 'date-fns'

// An Android sender counts as online if it contacted the server in the last 15 minutes.
export const SMS_ONLINE_WINDOW_MS = 15 * 60 * 1000

export type DeviceState = 'online' | 'ready' | 'offline' | 'disconnected'

export const getDeviceLabel = (d: any): string => {
  if (!d) return ''
  if (d.displayName) return d.displayName
  const hardware = [d.brand, d.model].filter(Boolean).join(' ')
  if (hardware) return hardware
  return d.gatewayType === 'whatsapp' ? 'WhatsApp number' : 'Unnamed phone'
}

export const getDeviceState = (d: any): { state: DeviceState; word: string; detail: string } => {
  if (d?.gatewayType === 'whatsapp') {
    return d.whatsappStatus === 'ready'
      ? { state: 'ready', word: 'ready', detail: 'ready' }
      : { state: 'disconnected', word: 'not linked', detail: 'not linked' }
  }
  const ping = d?.lastPingAt ? new Date(d.lastPingAt).getTime() : 0
  if (ping && Date.now() - ping < SMS_ONLINE_WINDOW_MS) {
    return { state: 'online', word: 'online', detail: 'online' }
  }
  const ago = ping ? formatDistanceToNowStrict(ping) : ''
  return { state: 'offline', word: 'offline', detail: ago ? `offline · ${ago}` : 'offline' }
}

export const isDeviceUp = (d: any) => {
  const s = getDeviceState(d).state
  return s === 'online' || s === 'ready'
}

export const stateDotClass: Record<DeviceState, string> = {
  online: 'bg-status-delivered',
  ready: 'bg-status-delivered',
  offline: 'bg-status-offline',
  disconnected: 'bg-status-failed',
}

export const channelStripeClass = (d: any) =>
  d?.gatewayType === 'whatsapp' ? 'bg-channel-wa' : 'bg-channel-sms'
